export enum TEST {
    PSYCHOMETRIC = 'PSYCHOMETRIC',
    CODING = 'CODING',
    ALL = 'ALL'
}

export const middot = '\u00A0\u00A0\u00B7\u00A0\u00A0';
